<template>
  <div id="toReconcileExpensesComponent">
    <v-layout>
      <page-title :heading=heading :subheading=subheading :icon=icon class="mr-5">
      </page-title>
      <h2 class="ml-5 mt-4 subtitle-1">{{$t('conciliation.period')}}: {{dateFormat(startDate)}} - {{dateFormat(endDate)}}</h2>
    </v-layout>
    <v-container class="py-0 my-0">
      <v-flex class="text-xs-right py-0 my-0">
        <v-btn
          color="primary"
          round
          outline
          :loading="downloadLoading"
          @click="downloadXls('download')"
        >
          {{$t('conciliation.download')}}
          <v-icon right>cloud_download</v-icon>
        </v-btn>
      </v-flex>
      <v-flex class="text-xs-right py-0 my-0">
        <v-dialog
          persistent
          v-model="dialog"
          max-width="700px"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              round
              outline
              v-on="on"
            >
              <v-icon left>filter_list</v-icon>
              {{$t('general.filter')}}
            </v-btn>
          </template>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{$t('general.filter')}}</h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-form
                lazy-validation
                ref="form"
                v-model="valid"
                >
                  <v-layout>
                    <v-flex xs6>
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            :rules="rules.required"
                            :error-messages="errors.startDate"
                            v-model="startDate"
                            :label="$t('general.startDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :max="endDate"
                          color="primary"
                          v-model="startDate"
                          @input="menu = false"
                          :locale="$t('history.local')"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6>
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            :rules="rules.required"
                            v-model="endDate"
                            :error-messages="errors.endDate"
                            :label="$t('general.endDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="endDate"
                          @input="menu2 = false"
                          :max="new Date().toISOString().substr(0, 10)"
                          :min="startDate"
                          :locale="$t('history.local')"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex>
                      <v-switch
                        color="primary"
                        v-model="switchAllEmployees"
                        :label="switchAllEmployees
                          ? $t('expenseDetailEmployee.allEmployees')
                          : $t('expenseDetailEmployee.perEmployee')"
                      ></v-switch>
                      <v-autocomplete
                        v-if="!switchAllEmployees"
                        v-model="selectedEmployee"
                        item-text="name"
                        item-value="id"
                        persistent-hint
                        :rules="rules.required"
                        :items="employees"
                        :label="$t('expenseDetailEmployee.employee')"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                  <v-flex xs8>
                    <v-radio-group v-model="expense_type" column :label="$t('conciliation.searchType')" label-size="sm">
                    <v-radio :label="$t('pettyCash.title')" value="petty_cash"></v-radio>
                    <v-radio :label="$t('amexCard.title')" value="amex"></v-radio>
                    <!-- <v-radio :label="$t('conciliation.filter.advances')" value="all"></v-radio> -->
                    <v-radio :label="$t('conciliation.filter.all')" value="all"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                round
                flat
                @click="close"
              >
                {{$t('general.close')}}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                round
                depressed
                @click="send"
              >
                {{$t('general.submit')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <b-row>
        <!-- Monto TC -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content yellow-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">{{$t('conciliation.tCAmount')}}:</div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular indeterminate size="20"></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ allAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto conciliado Bluespend -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content green-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">{{$t('conciliation.bluespendReconciledAmount')}}:</div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular indeterminate size="20"></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ consiliateAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto Faltante -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content red-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">{{$t('conciliation.missingAmount')}}:</div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular indeterminate size="20"></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ missingAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto Excluidos -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content blue-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">{{$t('conciliation.excludedAmount')}}:</div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular indeterminate size="20"></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ excludedAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Filtro Empleados -->
        <b-col class="px-2" col-md-12 col-xl-12 v-if="userLogged.roles && userLogged.roles[0].name === 'ADMIN' && selectedEmployee">
          <b-card class="ma-0 pa-0 widget-content bg-info">
            <div class="text-white ma-0 pa-0">
              <div class="ma-0 pa-0">
                <div class="text-white text-center" v-if="!selectedEmployee">
                  <v-progress-circular indeterminate size="20"></v-progress-circular>
                </div>
                <div class="text-white ma-0 pa-0" v-else>
                  <v-autocomplete
                    v-model="selectedEmployee"
                    item-text="name"
                    item-value="id"
                    :rules="rules.required"
                    :items="employees"
                    class="select-employee"
                    @change="selectedEmployeeChange()"
                  >
                    <template #selection="{ item }">
                      <span class="select-employee text-white text-truncate">{{item.name}}</span>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    <v-spacer class="my-3"></v-spacer>
      <template variant="primary" v-slot:title>
        <h5 class="my-0">{{$t('conciliation.status.toConciliate')}}</h5>
      </template>
      <v-flex>
        <v-toolbar flat color="bg-sidebar" dark>
        <h2 class="my-0">{{$t('conciliation.status.toConciliate')}}</h2>
        <v-spacer></v-spacer>
        <v-text-field
          color="light"
          v-model="searchConciliation"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
        </v-toolbar>
        <v-data-table
          :search="searchConciliation"
          :loading-text="$t('general.loadingText')"
          :no-data-text="$t('general.noDataText')"
          class="elevation-2"
          :headers="headers"
          :items="toReconcileExpenses"
          :loading="loadingItems"
          :rows-per-page-items="[10,15,25]"
          :pagination.sync="pagination"
          item-key="amex_expense.id"
          show-expand
          :expand="expand">
          <template v-slot:headers="props">
            <tr class="bg-heavy-rain">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
                >
                <h2 class="font-weight-black primary--text mb-0">
                  <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                  {{ header.text }}
                </h2>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr class="" @click="props.expanded = !props.expanded">
              <td class="font-weight-black" style="max-width: 20px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="!props.expanded"
                      v-on="on"
                      color="primary"
                      >
                      mdi-chevron-down
                    </v-icon>
                    <v-icon
                      v-else
                      v-on="on"
                      color="primary"
                      >
                      mdi-chevron-up
                    </v-icon>
                  </template>
                  <span>
                    {{!props.expanded ?
                      $t('general.extend') : $t('general.collapse')}}
                  </span>
                </v-tooltip>
              </td>
              <td class="text-sm-center" width="20px">{{props.item.amex_expense.id}}</td>
              <td class="text-sm-center" width="150px">{{props.item.amex_expense.date}}</td>
              <td class="text-sm-center">{{props.item.amex_expense.transaction_number}}</td>
              <td class="text-sm-center">{{props.item.amex_expense.description}}</td>
              <td class="text-sm-center">{{props.item.amex_expense.user.name}}</td>
              <td class="text-sm-center">{{props.item.amex_expense.supplier_name}}</td>
              <td class="text-sm-center">{{props.item.amex_expense.amount | formatCurrency}}</td>
              <td class="text-sm-left" v-if="props.item.matches.length > 0">
                <v-btn
                    small
                    color="success"
                  >
                    {{$t('conciliation.found')}}
                  </v-btn>
                <ul>
                  <li v-for="match in props.item.matches" :key="match.id">
                    {{match.description}} {{match.id}} {{match.date}} {{match.total_mxn}}
                  </li>
                </ul>
              </td>
              <td class="text-sm-left" v-else>
                <v-btn
                    small
                    color="error"
                  >
                    {{$t('conciliation.notFound')}}
                  </v-btn>
              </td>
              <td class="text-sm-left" style="max-width: 70px, margin-left: 0, padding-left: 0">
                <v-tooltip
                top >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="excludeAMEXConfirm(props.item.amex_expense.id)"
                      icon
                      v-on="on">
                      <v-icon
                      color="#D4824B"
                      >fa fa-sign-out-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('conciliation.excludeAMEX') }}</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <v-card flat :key="props.item.amex_expense.id">
              <v-layout v-if="props.item.matches.length !== 0">
                  <p class="text-md-left mx-4 mt-3">{{$t('conciliation.foundMessage')}}</p>
                  <v-btn
                    @click="searchExpense(props.item)"
                    :loading="searchLoading"
                    small
                    tile
                    class="ml-3 mt-3"
                  >
                    <v-icon
                    color="primary"
                    class="mr-2"
                    small
                    >mdi-rotate-3d-variant</v-icon>
                    {{$t('conciliation.searchAgain')}}
                  </v-btn>
                <!-- </v-flex> -->
              </v-layout>
              <v-layout v-if="props.item.matches.length === 0">
                <v-flex xs12>
                  <p class="text-sm-left ml-4 mt-3">{{'No se encontraron registros'}}</p>
                  <v-btn
                    @click="searchExpense(props.item)"
                    :loading="searchLoading"
                    small
                    tile
                    class="ml-3 mt-3"
                  >
                    <v-icon
                    color="primary"
                    class="mr-2"
                    small
                    >mdi-rotate-3d-variant</v-icon>
                    {{$t('conciliation.searchAgain')}}
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout v-if="props.item.matches.length !== 0">
                <v-flex xs12>
                  <table width="100%">
                    <thead>
                      <th class="text-sm-center font-weight-black">#</th>
                      <th class="text-sm-center font-weight-black">{{$t('conciliation.date')}}</th>
                      <th class="text-sm-center font-weight-black">{{$t('conciliation.description')}}</th>
                      <th class="text-sm-center font-weight-black">{{$t('conciliation.statusLabel')}}</th>
                      <th class="text-sm-center font-weight-black">{{$t('conciliation.user')}}</th>
                      <th class="text-sm-center font-weight-black">{{$t('conciliation.amount')}}</th>
                      <th class="text-sm-center font-weight-black">{{$t('conciliation.uuid')}}</th>
                      <th class="text-sm-center font-weight-black">{{$t('general.actions')}}</th>
                    </thead>
                    <tr v-for="item of props.item.matches" :key="item.id">
                      <td class="text-sm-center">{{item.id}}</td>
                      <td class="text-sm-center">{{item.date}}</td>
                      <td class="text-sm-center">{{item.description}}</td>
                      <td class="text-sm-center">
                        <v-chip
                          :color ="getColor(item.gst_expenses.status_expense.name)"
                          class="font-weight-black"
                          dark
                          small
                        >{{getStatus(item.gst_expenses.status_expense.name)}}</v-chip>
                        </td>
                      <td class="text-sm-center">{{item.gst_expenses.user.name}}</td>
                      <td class="text-sm-center">{{item.total_mxn | formatCurrency}}</td>
                      <td class="text-sm-center">{{item.uuid}}</td>
                      <td class="text-sm-center">
                      <v-tooltip top v-if="item.gst_receipt_types_id === 2">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="viewExpenses(0,item)"
                            small
                            icon
                            outline
                            color="primary"
                            v-on="on">
                            <v-icon small>remove_red_eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('general.seeMore') }}</span>
                      </v-tooltip>
                      <v-tooltip top v-else>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            icon
                            @click="viewExpenses(props.item.amex_expense.id,item)"
                            outline
                            color="primary"
                            v-on="on">
                            <v-icon small>remove_red_eye</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('general.seeMore') }}</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="showTip(item)">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :disabled="props.item.subtotal === null"
                            small
                            outline
                            icon
                            color="warning"
                            v-on="on"
                            @click="addTip(item)"
                            >
                            <v-icon small>fa fa-donate</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('expenses.seeTip') }}</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="conciliationConfirm(props.item.amex_expense.id, item)"
                            icon
                            v-on="on">
                            <v-icon
                            color="#00C24E"
                            >mdi-check-circle</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('conciliation.conciliateExpense') }}</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="excludeConfirm(item)"
                            icon
                            v-on="on">
                            <v-icon
                            color="#D4824B"
                            >fa fa-sign-out-alt</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('conciliation.exclude') }}</span>
                      </v-tooltip>
                      </td>
                    </tr>
                      <tr  v-for="item of props.item.matches" :key="item.id">
                      <td colspan="4" v-if="item.tip">
                      </td>
                      <td colspan="4" v-if="item.tip">Total + propina = {{new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(item.tip.amount) + Number(item.total_mxn))}}</td>
                    </tr>
                    </table>
                </v-flex>
              </v-layout>
            </v-card>
          </template>
        </v-data-table>
      </v-flex>
      <v-dialog
        persistent
        v-model="conciliateDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar
            flat
          >
            <h2 class="font-weight-black primary--text mb-0">{{ $t('conciliation.conciliateExpense') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('conciliation.conciliateQuestion') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="conciliateDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="primary"
              round
              depressed
              @click="conciliate(conciliateItem)"
            >
              {{ $t('conciliation.conciliate') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        persistent
        v-model="excludeDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar
            flat
          >
            <h2 class="font-weight-black error--text mb-0">{{ $t('conciliation.excludeExpense') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('conciliation.excludeQuestion') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="excludeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="exclude(excludeItem)"
            >
              {{ $t('conciliation.exclude') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        persistent
        v-model="excludeAMEXDialog"
        max-width="500px"
      >
        <v-card>
          <v-toolbar
            flat
          >
            <h2 class="font-weight-black error--text mb-0">{{ $t('conciliation.excludeExpense') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('conciliation.excludeQuestion') }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="excludeAMEXDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="excludeAMEX(excludeAMEXItem)"
            >
              {{ $t('conciliation.exclude') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogItem"
        scrollable
        max-width="900px"
        persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{$t('workflowValidation.item' )}}{{ editedItem.id }} <span> ( {{editedItem.gst_receipt_types_id === 1 ? 'Fiscal' : 'No Fiscal'}} )</span></h2>
          </v-toolbar>
          <template v-if="editedItem.gst_receipt_types_id === 1">
            <v-card-text class="text-center" v-if="!cfdiHtml">
              <v-progress-circular class="my-5" indeterminate size="70" color="primary" />
            </v-card-text>
            <v-card-text v-else>
              <iframe
                name="cfdi"
                :srcdoc="cfdiHtml"
                style="width:845px; height:1200px; border:0">
              </iframe>
              <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12 md6>
                      <v-text-field
                        :label="$t('general.category')"
                        disabled
                        outline
                        :value="editedItem.gst_categories.name ? editedItem.gst_categories.name : ''">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        :label="$t('general.comment')"
                        disabled
                        outline
                        v-model="editedItem.comment">
                      </v-textarea>
                    </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </template>
          <template v-if="editedItem.gst_receipt_types_id === 2">
            <v-card-text class="text-center" v-if="loadItem">
              <v-progress-circular class="my-5" indeterminate size="70" color="primary" />
            </v-card-text>
            <v-card-text v-else>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex layout row wrap v-bind:class="{'xs6': dataURL}">
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.date')}}</strong></p>
                      <p class="text-sm-left">{{editedItem.date}}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.category')}}</strong></p>
                      <p class="text-sm-left">{{editedItem.gst_categories ? editedItem.gst_categories.name : ''}}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.country')}}</strong></p>
                      <p class="text-sm-justify">{{editedItem.country && editedItem.country.descripcion}}</p>
                    </v-flex>
                    <v-flex xs12>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.description')}}</strong></p>
                      <p class="text-sm-left">{{editedItem.description && editedItem.description}}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.currency')}}</strong></p>
                      <p class="text-sm-left">{{editedItem.currency && editedItem.currency.c_Moneda}} - {{editedItem.currency && editedItem.currency.descripcion}}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.exchangeRate')}}</strong></p>
                      <p class="text-sm-left">{{editedItem.exchange}}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.subtotal')}}</strong></p>
                      <p class="text-sm-left">${{editedItem.subtotal}} {{editedItem.currency.c_Moneda}}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.total')}}</strong></p>
                      <p class="text-sm-left">${{editedItem.total}} {{editedItem.currency.c_Moneda}}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.formaPago')}}</strong></p>
                      <p class="text-sm-left">{{editedItem.sat_forma_pago && editedItem.sat_forma_pago.descripcion}}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.folioRef')}}</strong></p>
                      <p class="text-sm-left">{{editedItem.folio}}</p>
                    </v-flex>
                    <v-flex xs6>
                      <p class="primary--text mb-0 text-sm-left"><strong>{{$t('general.comment')}}</strong></p>
                      <p class="text-sm-justify">{{editedItem.comment}}</p>
                    </v-flex>
                  </v-flex>
                  <v-flex xs6 layout v-if="dataURL">
                    <v-flex xs12>
                      <a v-if="!isPDF(dataURL)" @click="openPDF()">
                        <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                      </a>
                      <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                        <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                      </v-btn>
                      <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              flat
              round
              class="white--text"
              depressed
              @click="close">
              {{$t('general.cancel')}}
            </v-btn>
            <v-btn
              color="primary"
              round
              depressed
              @click="conciliationConfirm(amexId, editedItem)">
              {{$t('conciliation.conciliate')}}
            </v-btn>
            <!-- <v-btn
              color="success darken-1"
              round
              flat
              :loading="loadingXML"
              @click="downloadXML"
            >
              {{$t('general.downloadXML')}}
            </v-btn>
            <v-btn :disabled="!cfdiHtml" round flat color="primary" @click="sendToPrint()"><v-icon left>print</v-icon> {{$t('general.print')}}</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
      v-model="dialogTip"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black primary--text mb-0">{{formTitleTip}}</h2>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-form
                ref="tipForm"
                lazy-validation>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItemTip.amount"
                        :error-messages="errors.amount"
                        :rules="rules.required"
                        :label="$t('general.amount')"
                        >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 layout v-if="dataURL">
                    <v-flex xs12>
                      <label>{{$t('expenses.file')}}:</label>
                      <a v-if="!isPDF(dataURL)" @click="openPDF()">
                        <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                      </a>
                      <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                        <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                      </v-btn>
                      <iframe v-if="isPDF(dataURL)" :src="dataURL" frameborder="0" width="100%" height="400px"></iframe>
                    </v-flex>
                    </v-flex>
                    <v-flex xs12>
                      <vue-dropzone v-if="editedItemTip.created_at === ''"
                        ref="dropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-file-added="fileAdded"
                        v-on:vdropzone-error="fileUploadError"
                        v-on:vdropzone-success="fileUploadTip">
                      </vue-dropzone>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="editedItemTip.created_at !== ''"
            round
            flat
            color="primary darken-1"
            @click="closeDialogTip()">
            {{ $t('general.close') }}
          </v-btn>
          <v-btn
            v-if="editedItemTip.created_at === ''"
            round
            flat
            color="primary darken-1"
            @click="closeDialogTip()">
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
            v-if="editedItemTip.created_at === ''"
            round
            color="primary"
            :loading="loading"
            :disabled="loading"
            @click="submitTip()">
            {{ $t('general.submit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import vue2Dropzone from 'vue2-dropzone'

import {
  faHandshake,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
library.add(
  faHandshake,
  faSignOutAlt
)
export default {
  name: 'toReconcileExpensesComponent',
  components: {
    vueDropzone: vue2Dropzone,
    'font-awesome-icon': FontAwesomeIcon
  },
  data () {
    return {
      totalPending: 0,
      totalAmounts: [],
      allAmount: 0,
      consiliateAmount: 0,
      excludedAmount: 0,
      missingAmount: 0,
      searchConciliation: '',
      dialog: false,
      dialog2: false,
      dialogItem: false,
      valid: true,
      menu: false,
      menu2: false,
      loading: false,
      loadItem: false,
      expand: false,
      conciliateDialog: false,
      excludeDialog: false,
      excludeAMEXDialog: false,
      filter_by: 'company',
      cfdiHtml: null,
      amexId: 0,
      conciliateItem: {
        expense_amex_id: 0,
        expense_item_id: 0,
        status: ''
      },
      excludeItem: {
        id: 0,
        exclude: true
      },
      excludeAMEXItem: {
        expense_amex_id: 0
      },
      errors: {},
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      downloadLoading: false,
      searchLoading: false,
      loadingItems: false,
      userLogged: {},
      toReconcileExpenses: [],
      excludedExpenses: [],
      allExpenses: [],
      tab_1_filters: 1,
      isEditing: false,
      expense_type: 'amex',
      excludedType: 'AMEX',
      excludedTypes: [
        {
          id: 1,
          text: 'AMEX',
          value: 'AMEX'
        },
        {
          id: 2,
          text: 'BLUESPEND',
          value: 'BLUESPEND'
        }
      ],
      status: 'CONSILIATE',
      conciliatedItems: [],
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0
      },
      expense_typeFilter: [
        {
          name: this.$t('conciliation.filter.all'),
          value: 'all'
        },
        {
          name: this.$t('pettyCash.title'),
          value: 'small_box'
        },
        {
          name: this.$t('amexCard.title'),
          value: 'amex'
        }
      ],
      dataURL: null,
      editedItem: {
        gst_categories: {
          name: ''
        },
        receipt_type: {
          name: ''
        }
      },
      editedItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: ''
      },
      defaultItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: ''
      },
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', { size: '5', unit: 'MB' }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        resizeWidth: 1080,
        resizeHeight: 1080,
        resizeMethod: 'contain',
        resizeQuality: 0.8,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png,.pdf',
        maxFiles: 1,
        headers: { 'Authorization': 'Bearer ' + this.$store.state.userState.access_token },
        params: {
          'user_id': this.$store.state.userLogged.id,
          'dirname': 'IMG_EXPENSES'
        }
      },
      dialogTip: false,
      employees: [],
      switchAllEmployees: true,
      selectedEmployee: null,
      companyId: null
    }
  },
  computed: {
    heading () {
      return this.$t('conciliation.titleToReconcile')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fa fa-handshake fa-fw icon-color'
    },
    rules () {
      return this.$validationRules()
    },
    headers () {
      return [
        {
          text: '',
          align: 'center',
          sortable: false
        },
        {
          text: '#',
          align: 'center',
          value: 'amex_expense.id',
          sortable: true
        },
        {
          text: this.$t('conciliation.date'),
          align: 'center',
          value: 'amex_expense.date',
          sortable: true
        },
        {
          text: this.$t('conciliation.transactionNo'),
          align: 'center',
          value: 'amex_expense.transaction_number',
          sortable: true
        },
        {
          text: this.$t('conciliation.description'),
          align: 'center',
          value: 'amex_expense.description',
          sortable: true
        },
        {
          text: this.$t('conciliation.user'),
          align: 'center',
          value: 'amex_expense.user.name',
          sortable: true
        },
        {
          text: this.$t('conciliation.beneficiary'),
          align: 'center',
          value: 'amex_expense.supplier_name',
          sortable: true
        },
        {
          text: this.$t('conciliation.amount'),
          align: 'center',
          value: 'amex_expense.amount',
          sortable: true
        },
        {
          text: this.$t('conciliation.result'),
          align: 'center',
          value: 'matches',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    formTitleTip () {
      if (this.editedItemTip.created_at !== '') {
        return this.$t('expenses.tip')
      } else {
        return this.$t('expenses.addTip')
      }
    }
  },
  created () {
    this.getLogged()
  },
  watch: {
    '$store.state.userLogged' () {
      this.getLogged()
    },
    editedItem (value) {
      if (value.gst_receipt_types_id && value.gst_receipt_types_id === 2) {
        this.showExpenseItemFile()
      } else if (value.gst_receipt_types_id && value.gst_receipt_types_id === 1) {
        this.showXMLFile()
      }
    },
    switchAllEmployees (value) {
      if (value) {
        this.filter_by = 'company'
        this.selectedEmployee = null
      } else {
        this.filter_by = 'user'
      }
    }
  },
  methods: {
    filterAmounts () {
      this.allAmount = this.totalAmounts.all
      this.consiliateAmount = this.totalAmounts.consiliate
      this.excludedAmount = this.totalAmounts.excluded
      this.missingAmount = this.totalAmounts.null
    },
    dateFormat (date) {
      let formatted = date.replace(/-/g, '/')
      return formatted
    },
    selectedEmployeeChange () {
      this.get()
      this.calculateTotals()
    },
    getEmployees () {
      this.companyId = this.userLogged.company[0].id
      this.$store.dispatch('expenseDetailEmployee/getCompanyEmployee', {
        event: {
          context: this,
          item: {
            companyId: this.companyId
          }
        }
      })
    },
    getAmountExcluded () {
      let totalAmount = 0
      if (this.excludedExpenses.length > 0) {
        this.excludedExpenses.forEach(item => {
          totalAmount += parseFloat(item.amount)
        })
      }
      this.amountExcluded = totalAmount
    },
    getAmountAll () {
      let totalAmount = 0
      if (this.allExpenses.length > 0) {
        this.allExpenses.forEach(item => {
          totalAmount += parseFloat(item.amount)
        })
      }
      this.amountAll = totalAmount
    },
    getLogged () {
      let current = new Date()
      let before = new Date().setDate(current.getDate() - 30)
      let dateStart = new Date(before).toISOString().substr(0, 10)
      this.startDate = dateStart
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
        this.get()
        this.getEmployees()
        this.calculateTotals()
      }
    },
    getStatus (stat) {
      let str = ''
      switch (stat) {
        case 'exs.created':
          str = this.$t('expenses.exs.created')
          break
        case 'exs.sented':
          str = this.$t('expenses.exs.sented')
          break
        case 'exs.reviewed':
          str = this.$t('expenses.exs.reviewed')
          break
        case 'exs.payable':
          str = this.$t('expenses.exs.payable')
          break
        case 'exs.payment':
          str = this.$t('expenses.exs.payment')
          break
        case 'exs.paid':
          str = this.$t('expenses.exs.paid')
          break
        case 'exs.approved':
          str = this.$t('expenses.exs.approved')
          break
      }
      return str
    },
    getColor (stat) {
      let color = ''
      switch (stat) {
        case 'exs.created':
          color = '#0046FE'
          break
        case 'exs.sented':
          color = '#C3114B'
          break
        case 'exs.reviewed':
          color = '#FE5200'
          break
        case 'exs.payable':
          color = '#C6EA00'
          break
        case 'exs.payment':
          color = '#FEBD01'
          break
        case 'exs.paid':
          color = '#1BB219'
          break
        case 'exs.approved':
          color = '#0192D1'
          break
      }
      return color
    },
    close () {
      this.dialog = false
      this.conciliateDialog = false
      this.excludeDialog = false
      this.excludeAMEXDialog = false
      this.amexId = 0
      this.conciliateItem = {}
      this.exludeItem = {}
      this.exludeAMEXItem = {}
      this.dialog2 = false
      this.dialogItem = false
      this.loading = false
      this.loadingItems = false
      this.searchLoading = false
    },
    send () {
      this.get()
      this.calculateTotals()
      this.dialog = false
      this.loadingItems = true
    },
    downloadXls (type) {
      this.downloadReport()
    },
    downloadReport () {
      this.downloadLoading = true
      this.$emit('downloadReport', {
        filter_by: this.filter_by,
        user_id: this.selectedEmployee,
        company_id: this.userLogged.company[0].id,
        startDate: this.startDate,
        endDate: this.endDate,
        expense_type: this.expense_type,
        context: this
      })
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    get () {
      this.loadingItems = true
      this.$emit('get', {
        filter_by: this.filter_by,
        company_id: this.userLogged.company[0].id,
        user_id: this.selectedEmployee,
        startDate: this.startDate,
        endDate: this.endDate,
        expense_type: this.expense_type,
        context: this
      })
    },
    calculateTotals () {
      this.loading = true
      this.$emit('calculateTotals', {
        user_id: this.selectedEmployee,
        startDate: this.startDate,
        endDate: this.endDate,
        context: this
      })
    },
    getExpensesAMEX (status) {
      switch (status) {
        case 'all':
          this.status = null
          break
        case 'excluded':
          this.status = 'EXCLUDED'
          break
      }
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        if (this.excludedType === 'AMEX') {
          this.$store.dispatch('conciliation/getExpensesAMEX', {
            event: {
              context: this,
              status: this.status,
              userId: null,
              startDate: this.startDate,
              endDate: this.endDate
            }
          })
        } else if (this.excludedType === 'BLUESPEND') {
          this.$store.dispatch('conciliation/getExcludedBLUESPEND', {
            event: {
              item: {
                company_id: this.userLogged.company[0].id,
                startDate: this.startDate,
                endDate: this.endDate,
                userId: null,
                type: 'json'
              },
              context: this
            }
          })
        }
      } else if (this.userLogged.roles && this.userLogged.roles[0].name === 'EMPLOYEE') {
        if (this.excludedType === 'AMEX') {
          this.$store.dispatch('conciliation/getExpensesAMEX', {
            event: {
              context: this,
              userId: this.userLogged.id,
              status: this.status,
              startDate: this.startDate,
              endDate: this.endDate
            }
          })
        } else if (this.excludedType === 'BLUESPEND') {
          this.$store.dispatch('conciliation/getExcludedBLUESPEND', {
            event: {
              item: {
                company_id: this.userLogged.company[0].id,
                startDate: this.startDate,
                endDate: this.endDate,
                userId: this.userLogged.id,
                type: 'json'
              },
              context: this
            }
          })
        }
      }
    },
    conciliationConfirm (amexId, item) {
      this.conciliateItem.expense_amex_id = amexId
      this.conciliateItem.expense_item_id = item.id
      this.conciliateItem.status = 'CONSILIATED'
      this.conciliateDialog = true
    },
    excludeConfirm (item) {
      this.excludeItem.id = item.id
      this.excludeItem.excluded = true
      this.excludeDialog = true
    },
    excludeAMEXConfirm (amexId) {
      this.excludeAMEXItem.expense_amex_id = amexId
      this.excludeAMEXDialog = true
    },
    conciliate (item) {
      this.loadingItems = true
      this.$emit('matchExcludeItem', {
        expense_amex_id: item.expense_amex_id,
        expense_item_id: item.expense_item_id,
        // status: item.status,
        context: this
      })
    },
    exclude (item) {
      this.loadingItems = true
      this.$emit('excludeItem', {
        id: item.id,
        excluded: item.excluded,
        context: this
      })
    },
    excludeAMEX (item) {
      this.loadingItems = true
      this.$emit('matchExcludeItem', {
        expense_amex_id: item.expense_amex_id,
        status: 'EXCLUDED',
        context: this
      })
    },
    searchExpense (item) {
      this.loadingItems = true
      this.searchLoading = true
      this.$emit('searchExpensesAMEX', {
        expense_amex_id: item.amex_expense.id,
        context: this
      })
    },
    refresh () {
      this.get()
    },
    viewExpenses (amexId, item) {
      this.amexId = amexId
      this.editedItem = item
      this.loadItem = true
      this.dialogItem = true
      this.$store.dispatch('expensesItems/getItem', {
        event: {
          id: item.id,
          context: this
        }
      })
    },
    isPDF (data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF () {
      var tab = window.open()
      tab.document.write('<body style="margin: 0;"> <iframe src="' + this.dataURL + '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>')
    },
    showExpenseItemFile () {
      if (this.editedItem.gst_expenses_items_files !== undefined && this.editedItem.gst_expenses_items_files !== null) {
        if (this.editedItem.gst_expenses_items_files.length > 0) {
          this.$store.dispatch('getFile', {
            event: {
              context: this,
              fileId: this.editedItem.gst_expenses_items_files[0].files_id
            }
          })
        }
      }
    },
    showXMLFile () {
      if (this.editedItem.gst_expenses_items_files !== null) {
        this.$store.dispatch('readXmlToHtml', {
          event: {
            id: this.editedItem.gst_expenses_items_files[0].files_id,
            context: this
          }
        })
      }
    },
    showTip (item) {
      if (item.tip !== null) {
        return true
      } else {
        return false
      }
    },
    addTip (item) {
      this.editedItemTip.id = item.id
      this.getTip(item)
      this.dialogTip = true
    },
    getTip (item) {
      this.$emit('getTip', {
        context: this,
        id: item.id
      })
    },
    closeDialogTip () {
      this.dialogTip = false
      this.editedItemTip = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItemTip)))
      this.editedIndexTip = -1
      this.reset()
    },
    reset () {
      if (this.$refs.dropzone !== undefined) {
        this.$refs.dropzone.removeAllFiles()
      }
      this.dataURL = null
    },
    fileAdded (file) {
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      let fileType = file.type
      if (fileType === 'image/jpeg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      } else if (fileType === 'application/pdf') {
        this.dropzoneOptions.params.files_type_id = 3
      }
    },
    fileUploadError (file, message, xh) {
      this.showNotification(message, 'error', -1)
      this.errorMessage = message.errors.path[0]
    },
    fileUploadTip (file, response) {
      this.editedItemTip.fileId = response.data.id
    },
    submitTip () {
      if (this.$refs.tipForm.validate()) {
        this.loading = true
        if (this.editedItemTip.fileId !== null && this.editedItemTip.fileId !== undefined) {
          this.postTip()
        } else {
          this.loading = false
          this.showNotification(this.$t('expenseItems.noFileUploaded'), 'error', -1)
        }
      }
    },
    postTip () {
      this.$emit('postTip', {
        item: this.editedItemTip,
        context: this
      })
    },
    getFile (fileId) {
      this.$store.dispatch('getFile', {
        event: {
          context: this,
          fileId: fileId
        }
      })
    }
  }
}
</script>

<style scoped>
th {
  padding: 0 5px !important;
}

.yellow-block {
  background-color: #F8E9A1 !important;
}
.blue-block{
  background-color: #D8E8F8 !important;
}
.green-block{
  background-color: #B2E8D1 !important;
}
.red-block{
  background-color: #F4C7C3 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/toReconcileExpenses.component.vue